import React from "react";
import { SessionAuth } from "supertokens-auth-react/recipe/session";
import { PermissionClaim } from "supertokens-auth-react/recipe/userroles";
import Heading from "../../ui/Heading";

function AccessDeniedScreen() {
  return (
    <>
      <div className="text-center space-y-2">
        <Heading as="h1">Access denied</Heading>
        <p className="text-muted-foreground">
          Please upgrade your account to access this page.
        </p>
      </div>
    </>
  );
}

function PermissionProtected(props) {
  return (
    <SessionAuth
      accessDeniedScreen={AccessDeniedScreen}
      overrideGlobalClaimValidators={(globalValidators) => [
        ...globalValidators,
        PermissionClaim.validators.includes(props.permission),
      ]}
    >
      {props.children}
    </SessionAuth>
  );
}

export default PermissionProtected;
